import { createSlice } from '@reduxjs/toolkit';
// import { message as toaster } from 'antd';
import { API } from 'api';

const initialState = {};

export const locationSlice = createSlice({
	name: 'locationState',
	initialState,
	reducers: {},
});

export const getLocationDetails =
	({ search_type = '', filter_by = {} }) =>
	async () => {
		console.log('search_type 1', search_type);
		console.log('filter_by 1', filter_by);

		const CREDENTIALS = {
			url: '/search',
			data: {
				search_type,
				filter_by: {
					...filter_by,
				},
			},
		};

		return API.common(CREDENTIALS).then((response) => ({
			rows: response?.data,
			count: response?.count,
		}));
	};

export default locationSlice.reducer;
